import {
  permissionDeniedResponseSchema,
  listApiKeysResponseSchema,
  createApiKeyRequestSchema,
  createApiKeyResponseSchema,
  cancelApiKeyResponseSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

// Extend request objects only for the frontend with necessary path params
const CRUD = {
  d: z.object({ apiKeyId: z.string() }),
};

const endpoints = {
  'apiKeys.create': {
    method: 'POST',
    url: `${API_URL_BASE}api-keys`,
    requestSchema: createApiKeyRequestSchema,
    responseSuccessSchema: createApiKeyResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      403: permissionDeniedResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof createApiKeyRequestSchema,
    typeof createApiKeyResponseSchema,
    {
      403: typeof permissionDeniedResponseSchema;
    }
  >,
  'apiKeys.get.all': {
    method: 'GET',
    url: `${API_URL_BASE}api-keys`,
    requestSchema: z.undefined(),
    responseSuccessSchema: listApiKeysResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      403: permissionDeniedResponseSchema,
    },
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof listApiKeysResponseSchema,
    {
      403: typeof permissionDeniedResponseSchema;
    }
  >,
  'apiKeys.revoke': {
    method: 'DELETE',
    url: `${API_URL_BASE}api-keys/:apiKeyId`,
    requestSchema: CRUD.d,
    responseSuccessSchema: cancelApiKeyResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      403: permissionDeniedResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof CRUD.d,
    typeof cancelApiKeyResponseSchema,
    {
      403: typeof permissionDeniedResponseSchema;
    }
  >,
};

export default endpoints;
